import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-card-type-one',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './card-type-one.component.html',
    styleUrl: './card-type-one.component.css'
})
export class CardTypeOneComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
}
